var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPersonCircleBig(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_26879",
    "data-name": "Group 26879",
    transform: "translate(-536.493 -398.908)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26870",
    "data-name": "Group 26870",
    transform: "translate(-1006.57 -842.578)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1536",
    "data-name": "Ellipse 1536",
    cx: 15,
    cy: 15,
    r: 15,
    transform: "translate(1543.063 1241.486)",
    fill: "#efefef"
  })), /*#__PURE__*/React.createElement("g", {
    id: "vuesax_bold_user",
    "data-name": "vuesax/bold/user",
    transform: "translate(437.493 219.908)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "user",
    transform: "translate(108 188)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M0,0H12V12H0Z",
    fill: "none",
    opacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M5.013,2.506A2.506,2.506,0,1,1,2.506,0,2.506,2.506,0,0,1,5.013,2.506Z",
    transform: "translate(3.494 1.003)",
    fill: "#424e55"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-3",
    "data-name": "Vector",
    d: "M4.541,0C2.038,0,0,1.684,0,3.759a.248.248,0,0,0,.25.251H8.833a.248.248,0,0,0,.25-.251C9.083,1.684,7.044,0,4.541,0Z",
    transform: "translate(1.459 7.238)",
    fill: "#424e55"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonCircleBig);
export default __webpack_public_path__ + "static/media/person_circle-big.db20b91251d50389af5272109fcaa70c.svg";
export { ForwardRef as ReactComponent };